import jwt from 'jwt-decode'
import * as storage from '../utils/storage'

export function UserCode() {
    const token = Token();

    if (token === null) {
        return;
    }

    const userData = jwt(token);

    return userData.UserCode;
}

export function EmployeeId() {
    const token = Token();

    if (token === null) {
        return;
    }

    const userData = jwt(token);

    return parseInt(userData.EmployeeId);
}

export function Company() {
    const token = Token();

    if (token === null) {
        return;
    }

    const userData = jwt(token);

    return userData.Company;
}

export function EmployeeCode() {
    const token = Token();

    if (token === null) {
        return;
    }

    const userData = jwt(token);

    return userData.EmployeeCode;
}

export function Worksite() {
    const token = Token();

    if (token === null) {
        return;
    }

    const userData = jwt(token);

    return userData.Worksite;
}

export function SessionGuid() {
    return storage.getSessionGuid();
}

export function Token() {
    return storage.getToken();
}